import React, { Component } from "react";
import { Provider } from "react-redux";

import configureStore, { history } from "./store";
import "./firebase/firebase";
import App from "./checkUser";

export const store = configureStore();

const MainApp = () => (
  <Provider store={store}>
    
    <App />
  </Provider>
);

export default MainApp;
